import { render } from "./DevToolbar.vue?vue&type=template&id=94083f68&scoped=true"
import script from "./DevToolbar.vue?vue&type=script&lang=js"
export * from "./DevToolbar.vue?vue&type=script&lang=js"

import "./DevToolbar.vue?vue&type=style&index=0&id=94083f68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94083f68"]])

export default __exports__